import { render, staticRenderFns } from "./ResetPasswordDefualt.vue?vue&type=template&id=709f8509&"
import script from "./ResetPasswordDefualt.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordDefualt.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordDefualt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports